var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "none"
    },
    viewBox: "0 0 40 40",
    id: "svg12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 26.67827,9.0716945 c -0.6569,0 -1.3138,-0.6050003 -1.3138,-1.2100557 v -5.04207 c 0,-0.6050471 0.6569,-1.2101696 1.3138,-1.2101696 0.6569,0 1.3137,0.6051225 1.3137,1.2101696 v 5.04207 c 0,0.6050554 -0.4379,1.2100557 -1.3137,1.2100557 z",
    id: "path2",
    style: {
      fill: "#31ad31",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.3218,9.0716945 c -0.65689,0 -1.31377,-0.6050003 -1.31377,-1.2100557 v -5.04207 c 0,-0.6050471 0.65688,-1.2101696 1.31377,-1.2101696 0.65687,0 1.31377,0.6051225 1.31377,1.2101696 v 5.04207 c -0.219,0.6050554 -0.6569,1.2100557 -1.31377,1.2100557 z",
    id: "path4",
    style: {
      fill: "#31ad31",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31ad31",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    d: "M 29.525547,37.201751 H 10.474439 c -5.693,0 -9.196386,-3.4861 -9.196386,-9.151 V 13.087367 c 0,-5.4470139 3.503386,-8.9331839 9.196386,-8.9331839 h 19.051108 c 2.8465,0 5.2551,0.8716 6.787801,2.39677 1.532799,1.52516 2.408599,3.9218519 2.408599,6.5364139 v 15.181384 c 0,5.6649 -3.5034,8.933 -9.1964,8.933 z M 10.474439,6.5509531 c -4.37923,0 -6.78781,2.6145101 -6.78781,6.7542139 v 14.963584 c 0,4.3576 2.40858,6.5364 6.78781,6.5364 h 19.051108 c 4.3792,0 6.787801,-2.3967 6.787801,-6.5364 V 13.087367 c 0,-1.96091 -0.656901,-3.7039934 -1.7517,-4.7933939 -1.094801,-1.08941 -2.846501,-1.74302 -5.036101,-1.74302 z",
    id: "path6"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmpty);
export default __webpack_public_path__ + "static/media/calendar-empty.3b519fe7aa6004b8b6cc97f8dd02418a.svg";
export { ForwardRef as ReactComponent };